export { SORT_TYPES } from './sortTypes';

export const LYBUNT_SYBUNT_COLUMNS = [
  { id: 'donor_name', label: 'Donor', defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'email', label: 'Email', defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'last_gift_at', label: 'Last Gift', defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'last_gift_amount', label: 'Last Gift Amount', defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'lifetime_total', label: 'Lifetime Total', defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'gift_count', label: 'Gifts', defaultVisible: true, sortable: true, sortType: 'number' },
  { id: 'suggested_ask', label: 'Suggested Ask', defaultVisible: true, sortable: true, sortType: 'currency', headerTooltip: "Suggested ask = the donor's last gift x 1.25, rounded to the nearest dollar." },
];

export const getDefaultVisibleColumns = () =>
  LYBUNT_SYBUNT_COLUMNS.filter((c) => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  LYBUNT_SYBUNT_COLUMNS.filter((c) => !c.defaultVisible && !c.alwaysVisible);
